import { useState } from 'react';
import { NJButton, NJLink, NJText } from '@engie-group/fluid-design-system-react';
import { useDevelopmentPlans } from './hooks';
import type { ProjectSummary } from './types';

export function DevelopmentPlansTable({ project, flash }: { project: ProjectSummary; flash: (message: string) => void }) {
  const [allPlans, setAllPlans] = useState(false);
  const plans = useDevelopmentPlans(project.id);
  const metric = (value: number | null) => value === null ? '—' : value.toLocaleString('fr-FR', { maximumFractionDigits: 1 });
  return (
    <div className="pcv3-wf-plans">
      <NJText as="strong">{project.planCount} plan{project.planCount > 1 ? 's' : ''} de développement</NJText>
      {plans.isLoading || plans.isError ? <NJText scale="sm" role={plans.isError ? 'alert' : 'status'}>
        {plans.isError ? 'Impossible de charger les plans.' : 'Chargement des plans…'}
      </NJText> : plans.data?.length ? (
        <div className="pcv3-plans-table" role="region" aria-label={`Plans de développement · ${project.name}`} tabIndex={0}>
          <table className="nj-table nj-table--striped nj-table--hover pcv3-data-table" id={`plans-table-${project.id}`} aria-label={`Plans de développement · ${project.name}`}>
            <colgroup>
              <col className="pcv3-plan-name-col" /><col className="pcv3-plan-buildings-col" />
              <col className="pcv3-plan-consumption-col" /><col className="pcv3-plan-length-col" /><col className="pcv3-plan-date-col" />
            </colgroup>
            <thead><tr>
              <th scope="col"><NJText scale="xs">Plan de développement</NJText></th>
              <th scope="col"><NJText scale="xs">Bâtiments</NJText></th>
              <th scope="col"><NJText scale="xs">Conso totale<br />GWh/an</NJText></th>
              <th scope="col"><NJText scale="xs">Tracé<br />km</NJText></th>
              <th scope="col" aria-sort="descending"><NJText scale="xs">Dernière modification ↓</NJText></th>
            </tr></thead>
            <tbody>{(allPlans ? plans.data : plans.data.slice(0, 2)).map((plan) => <tr key={plan.id}>
              <th scope="row"><NJLink href={`#${plan.id}`} size="sm" variant="contextual" onClick={(event) => {
                event.preventDefault();
                flash(`${plan.name} · détail du plan non disponible dans cette démonstration d’accueil`);
              }}>{plan.name}</NJLink></th>
              <td><NJText scale="sm">{metric(plan.buildingCount)}</NJText></td>
              <td><NJText scale="sm">{metric(plan.consumption)}</NJText></td>
              <td><NJText scale="sm">{metric(plan.networkLength)}</NJText></td>
              <td><NJText scale="sm">{plan.updatedAt}</NJText></td>
            </tr>)}</tbody>
          </table>
        </div>
      ) : <NJText scale="sm">Aucun plan de développement.</NJText>}
      {(plans.data?.length ?? 0) > 2 && <NJButton variant="secondary" scale="sm"
        label={allPlans ? 'Voir moins' : `Voir plus (+${(plans.data?.length ?? 0) - 2} plans)`}
        aria-expanded={allPlans} aria-controls={`plans-table-${project.id}`}
        onClick={() => setAllPlans((value) => !value)} />}
    </div>
  );
}
